import React from 'react';

import { useEmployersTableListQuery } from 'src/api';
import { EmployersInnerTable } from 'src/components/employer/EmployersTable/components/EmployersInnerTable';
import { TableThemes } from 'src/components/table';
import { useFilterStorage } from 'src/hooks/common';
import { useEmployersUnderPeoListQueryVariables } from 'src/hooks/employer';

interface PeosDetailsEmployersPeoPayrollProviderProps {
  peoId: string | undefined;
}

export const PeosDetailsEmployersPeoPayrollProvider: React.FC<
  PeosDetailsEmployersPeoPayrollProviderProps
> = ({ peoId }) => {
  const { pagination } = useFilterStorage();
  const queryVariables = useEmployersUnderPeoListQueryVariables(peoId);

  const {
    data: employers,
    loading,
    refetch,
  } = useEmployersTableListQuery({
    variables: queryVariables,
    skip: !peoId,
    notifyOnNetworkStatusChange: true,
  });

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  const employersList = React.useMemo(() => {
    return employers?.employerList ?? [];
  }, [employers?.employerList]);

  const employersCount = React.useMemo(() => {
    return employers?.employerCount || 0;
  }, [employers?.employerCount]);

  return (
    <EmployersInnerTable
      employersList={employersList}
      employersCount={employersCount}
      loading={loading}
      tableTheme={TableThemes.withBorderWithoutProfileIcon}
      pagination={pagination}
      onRefresh={refetchData}
    />
  );
};
